import React from 'react';

const PrivacyPolicy = () => {
    return (
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
                <div className="bg-gradient-to-r from-indigo-600 to-purple-600 px-6 py-8">
                    <h1 className="text-3xl md:text-4xl font-bold text-white">Privacy Policy</h1>
                    <p className="text-indigo-100 mt-2">Last updated: {new Date().getFullYear()}</p>
                </div>
                
                <div className="p-6 md:p-8 space-y-6">
                    <div>
                        <h2 className="text-xl font-bold text-gray-800 mb-3">1. Information We Collect</h2>
                        <p className="text-gray-600 leading-relaxed">
                            We collect information you provide directly to us, such as when you create an account, 
                            make a purchase, or contact us. This may include your name, email address, phone number, 
                            and payment information.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-xl font-bold text-gray-800 mb-3">2. How We Use Your Information</h2>
                        <p className="text-gray-600 leading-relaxed">
                            We use the information we collect to provide, maintain, and improve our services, 
                            process transactions, send you technical notices and support messages, and communicate 
                            with you about products and services.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-xl font-bold text-gray-800 mb-3">3. Information Sharing</h2>
                        <p className="text-gray-600 leading-relaxed">
                            We do not share your personal information with third parties except as necessary to 
                            provide our services (e.g., payment processing), comply with the law, or protect our rights.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-xl font-bold text-gray-800 mb-3">4. Data Security</h2>
                        <p className="text-gray-600 leading-relaxed">
                            We implement appropriate technical and organizational measures to protect your personal 
                            information against unauthorized access, alteration, disclosure, or destruction.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-xl font-bold text-gray-800 mb-3">5. Cookies</h2>
                        <p className="text-gray-600 leading-relaxed">
                            We use cookies and similar tracking technologies to track activity on our service and 
                            hold certain information to improve your experience.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-xl font-bold text-gray-800 mb-3">6. Contact Us</h2>
                        <p className="text-gray-600 leading-relaxed">
                            If you have any questions about this Privacy Policy, please contact us at:
                            <span className="block mt-2 text-indigo-600">abhapublicationindia@gmail.com</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;